import PdfLineItem from "../../pdf/types/PdfLineItem";
import InvoiceInformation from "./InvoiceInformation";
import Uuid from "./Uuid";

export default class Invoice {
    id: Uuid;
    stamped: boolean;
    loading: boolean;
    error: boolean;
    paused: boolean;
    downloaded: boolean;
    not_found: boolean;
    duplicated: boolean;
    excluded: boolean;
    invoice_information: InvoiceInformation;
    invoice_line_items: PdfLineItem[];
    purchase_order_line_items: PdfLineItem[];
    pdf_bytes: Uint8Array | null;
    stamped_pdf_bytes: Uint8Array | null;
    stamp_x: number;
    stamp_y: number;

    constructor() {
        this.id = new Uuid();
        this.stamped = false;
        this.loading = false;
        this.error = false;
        this.paused = false;
        this.downloaded = false;
        this.not_found = false;
        this.duplicated = false;
        this.excluded = true;
        this.invoice_information = new InvoiceInformation();
        this.invoice_line_items = [];
        this.purchase_order_line_items = [];
        this.pdf_bytes = null;
        this.stamped_pdf_bytes = null;
        this.stamp_x = -1;
        this.stamp_y = -1;
    }
}

